import React, { Component } from 'react';
import MapBox from './mapbox';
import MapChatbot from './mapChatbot';
import SearchBox from '../elements/searchBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SearchMenuBar from '../elements/searchMenuBar';
import InfoModal from "../elements/infoModal";
import RangeSlider from "../elements/slider";
import ModalFilter from '../elements/modalFilter';
import { geoCodeAddress, getHeatMap, jsonToGeoJSON, jsonToGeoJSONBusiness, jsonToGeoJSONDirectory, getCurrentGPSPosition, calculateDistance, extractCategories, getSpotCategory } from "../services/geolocation";
import { truncate, styleMapping, getEquivalent, isObjectComplete } from "../utils/tools";
import { getProfile } from "../../components/services/profile";
import { sendMapChatMessage } from "../../services/openRouterChat";
import { sendMapChatMessageViaBackend } from "../../services/mapChatBackend";
import { getMapChatMemory, saveMapChatMemory } from "../../utils/mapChatMemory";
import { getTheme, toggleTheme, applyTheme } from "../../utils/theme";
import $ from 'jquery';
import { connect } from 'react-redux';

const exceptionList = ['target_stereotype', 'target_age', 'target_stereotype', 'active', 'last_online', 'is_dark_mode', 'target_age', 'target_stereotype', 'is_premium', 'date_premium_valid', 'subscription']
const equivalentFields = [['target_age','age'],['target_gender','gender'],['target_orientation','orientation']];
const width = $(window).width();
const showGeoFilterUi = process.env.REACT_APP_SHOW_GEO_FILTERS !== 'false';
const showMapChatbotUi = process.env.REACT_APP_ENABLE_MAP_CHATBOT !== 'false';
const mapChatMode = ((process.env.REACT_APP_CHAT_MODE || 'frontend').toString().trim().toLowerCase());
const mapChatFallbackToFrontend = process.env.REACT_APP_CHAT_BACKEND_FALLBACK_TO_FE !== 'false';
const CHAT_PANEL_MARGIN = 12;
const CHAT_PANEL_WIDTH = 320;
const CHAT_PANEL_HEIGHT = 360;
const EMPTY_GEOJSON = { type: 'FeatureCollection', features: [] };

// export default class GeoLocation extends Component{    
class GeoLocation extends Component{    
    // ##################################  CONSTRUCTOR  ####################################
    // ##################################  CONSTRUCTOR  ####################################
    constructor(props) {
        super(props);
        let dNow = Date.now();
        let dEnd2 = new Date(dNow + 1000 * 3600 * 24 * 3);
        this.state = {
            emptyResults: true, 
            latitude: null, longitude: null, 
            dataPoints: null, 
            dataChatSuggestions: EMPTY_GEOJSON,
            loading: true, refresh: true, 
            infoModal: null, profile: null, 
            bComplete: null, bPopUp: true, popUpData: null, 
            debugUserCoordinates: '',
            modal: false,
            isRefreshing: false,
            searchRadiusMeters: 0,
            showRefreshMapButton: false,
            theme: getTheme(),
            chatEnabled: showMapChatbotUi,
            chatVisible: false,
            chatMessages: [],
            chatLoading: false,
            chatError: '',
            chatPosition: null,
            chatCollapsed: false,
            chatMode: mapChatMode,
            chatRecommendedEventKeys: [],
            chatRecommendedTitleHints: [],
            chatSuggestedEvents: [],
            chatBackendMeta: null
        };
        
        let t1 = new Date();
        t1.setHours(0,0,1)
        dEnd2.setHours(23,31,1)
        this.range = [t1.toUTCString(), dEnd2.toUTCString()];
        
        this.filterOpened = false;
        this.bdebug = false;
        this.searchRadiusMeters = 0;
        this.lastFetchedMapCenter = null;
        this.lastFetchRefreshDistanceMeters = 0;
        this.lastFetchedZoom = null;
        this.chatBusinessesFromGeoCall = [];
        this.chatSuggestionOverlay = EMPTY_GEOJSON;
        this.filters = {'gender': '', 'age': '', 'stereotype': '', 'political': '' };
        this.filteredDataPoints = {};
        this.suggestions=[];
        this.activeCategories = new Set();
        this.availableCategories = [];
        if(width > 980){this.styleMap = {height:'100vh',width: '100%'};}
        else{this.styleMap = {height:'100vh',width: '100%'};}
    }
    
    async componentDidMount() {
        $('.logo_container').css({'display': 'none'});
        applyTheme(this.state.theme);
        if (this.state.chatEnabled) {
            const memory = getMapChatMemory();
            this.setState({
                chatMessages: memory.messages,
                chatCollapsed: memory.collapsed,
                chatPosition: this.resolveInitialChatPosition(memory.position)
            });
        }
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.handleWindowResize);
        }
        // let coordinates = {latitude: 40.712749, longitude: -74.005994} 
        // let coordinates = {latitude: 45.467187, longitude: 9.183251};
        let coordinates = await getCurrentGPSPosition();
        this.coordinates = {'latitude': coordinates['latitude'], 'longitude': coordinates['longitude']}
        this.Lastcoordinates = this.coordinates;
        if(this.props.user){this.isProfile(this.props);}
        console.log('- geolocation cdm bf ischanged ', this.coordinates);
        await this.isChanged(this.coordinates, this.zoom, 'search');
        console.log('- geolocation cdm bf getResults ');
        await this.getResults();
        // window.AdProvider = window.AdProvider || [];
        // window.AdProvider.push({ "serve": {} });
    }
    

    async UNSAFE_componentWillReceiveProps(props){if(props.user){this.isProfile(props);}}

    componentWillUnmount(){
        $('.logo_container').css({'display': ''});
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.handleWindowResize);
        }
    }
  
    // ##################################  MAP CHANGED  ####################################
    // ##################################  MAP CHANGED  ####################################
    async isProfile(data){
        if(data.user.idUser){
            const temp = await getProfile(data.user.idUser);
            this.setState({profile: temp, bComplete: isObjectComplete(temp, exceptionList)}); 
        } else{this.setState({bComplete: false}); }
    }
    
    isChanged = async (coordinates, zoom, origin) => {
        this.coordinates = coordinates;

        if(zoom == null){this.zoom = 16;} else {this.zoom = zoom;}
        // console.log('- geolocation isChanged => ', coordinates);
        
        try{
            this.coordinatesTrunc = {'latitude': truncate(coordinates['latitude'],3), 'longitude': truncate(coordinates['longitude'],3)}
            this.suggestions = [];
            if(origin === 'search'){
                this.setState({loading: true, showRefreshMapButton: false });
                this.zoom = 16; 
                setTimeout(() => { this.getResults(); }, 200)          
            } 
            else {
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    const hasAnchor = (
                        this.lastFetchedMapCenter &&
                        Number.isFinite(this.lastFetchedMapCenter.latitude) &&
                        Number.isFinite(this.lastFetchedMapCenter.longitude)
                    );
                    if (!hasAnchor) {
                        return;
                    }

                    const refreshDistance = parseFloat(this.lastFetchRefreshDistanceMeters || 0);
                    if (!Number.isFinite(refreshDistance) || refreshDistance <= 0) {
                        return;
                    }

                    const distance = calculateDistance(this.lastFetchedMapCenter, coordinates);
                    const currentZoom = parseFloat(this.zoom);
                    const zoomChanged = (
                        Number.isFinite(this.lastFetchedZoom) &&
                        Number.isFinite(currentZoom) &&
                        Math.abs(currentZoom - this.lastFetchedZoom) >= 0.35
                    );
                    const shouldShowRefresh = (distance >= refreshDistance || zoomChanged);
                    const nextLat = parseFloat(coordinates['latitude']);
                    const nextLng = parseFloat(coordinates['longitude']);
                    const prevLat = parseFloat(this.state.latitude);
                    const prevLng = parseFloat(this.state.longitude);
                    const centerChanged = (
                        !Number.isFinite(prevLat) ||
                        !Number.isFinite(prevLng) ||
                        Math.abs(prevLat - nextLat) > 0.000001 ||
                        Math.abs(prevLng - nextLng) > 0.000001
                    );

                    if (shouldShowRefresh !== this.state.showRefreshMapButton || centerChanged) {
                        this.setState({
                            showRefreshMapButton: shouldShowRefresh,
                            latitude: nextLat,
                            longitude: nextLng
                        });
                    }
                }, 500);
            }
        }
        catch(e){
            console.log('eror no city : ', e)
        }

    }
    
    // ##################################  GET DENSITY  ####################################
    // ##################################  GET DENSITY  ####################################
    getResults = async () => {
        let debugUserCoordinates = '';
        this.suggestions=[];
        this.Lastcoordinates = this.coordinates;

        if(this.bdebug === true){
            debugUserCoordinates = await getCurrentGPSPosition();
        } 
        
        this.setState({ 
            latitude: this.coordinates['latitude'], 
            longitude: this.coordinates['longitude'], 
            loading: true, 
            showRefreshMapButton: false,
            debugUserCoordinates: JSON.stringify(debugUserCoordinates) 
        });

        this.dataPoints = await getHeatMap({
            'coordinates': this.coordinates, 
            'zoom': this.zoom, 
            'range': this.range
        }, this.props.directory);

        if (!this.dataPoints) {
            this.chatBusinessesFromGeoCall = [];
            this.setState({loading: false, refresh: true, showRefreshMapButton: false });
            return;
        }

        // Keep raw businesses from geolocation response for chatbot context (before UI filtering).
        this.chatBusinessesFromGeoCall = (Array.isArray(this.dataPoints['businesses']) ? [...this.dataPoints['businesses']] : []);

        const searchRadiusMeters = this.getSearchCircleRadiusMeters(this.coordinates, this.zoom);
        this.searchRadiusMeters = searchRadiusMeters;
        // Quarter of the circle diameter = half of the radius.
        this.lastFetchRefreshDistanceMeters = (searchRadiusMeters * 0.5);
        this.lastFetchedMapCenter = {
            latitude: parseFloat(this.coordinates.latitude),
            longitude: parseFloat(this.coordinates.longitude)
        };
        this.lastFetchedZoom = parseFloat(this.zoom);

        if (Array.isArray(this.dataPoints['businesses'])) {
            this.dataPoints['businesses'] = this.dataPoints['businesses'].filter((event, index, self) =>
                index === self.findIndex((e) => e.id_event === event.id_event)
            );
            this.dataPoints['businesses'] = this.applySearchCircleFilter(this.dataPoints['businesses'], searchRadiusMeters);
        } else {
            this.dataPoints['businesses'] = [];
        }

        if (Array.isArray(this.dataPoints['users'])) {
            this.dataPoints['users'] = this.applySearchCircleFilter(this.dataPoints['users'], searchRadiusMeters);
        }

        console.log('geolocation - getresults 3 => ', this.coordinates, ' => ',this.range, ' => ',this.dataPoints);

        this.availableCategories = extractCategories(this.dataPoints['businesses'], this.dataPoints['directory']);

        if (this.dataPoints){
            this.filterResults();
        } else {
            this.setState({loading: false, refresh: true, showRefreshMapButton: false });
        }

    }
    
    // ##################################  GET RANGE  ####################################
    // ##################################  GET RANGE  ####################################
    getRange = range => {
        // this.range = [new Date(range[0]), new Date(range[1])];
        this.range = [range[0], range[1]];
        // console.log('GEOLOCATION GETRANGE => ', this.range);
        this.getResults();
    }

    handleRefreshMap = async () => {
        if (this.state.isRefreshing || this.state.loading) {
            return;
        }

        this.setState({ isRefreshing: true });
        try {
            await this.getResults();
        } finally {
            this.setState({ isRefreshing: false });
        }
    }

    handleThemeToggle = () => {
        const nextTheme = toggleTheme();
        this.setState({ theme: nextTheme });
    }

    handleCategoryFilterChange = (updatedCategories) => {
        this.activeCategories = updatedCategories;
        this.preRender();
    }

    getDefaultChatPosition = () => {
        if (typeof window === 'undefined') {
            return { x: CHAT_PANEL_MARGIN, y: 96 };
        }

        return this.clampChatPosition({
            x: window.innerWidth - CHAT_PANEL_WIDTH - CHAT_PANEL_MARGIN,
            y: window.innerHeight - CHAT_PANEL_HEIGHT - 120
        });
    }

    clampChatPosition = (position) => {
        const defaultPosition = { x: CHAT_PANEL_MARGIN, y: 96 };
        const xRaw = parseFloat(position && position.x);
        const yRaw = parseFloat(position && position.y);
        if (!Number.isFinite(xRaw) || !Number.isFinite(yRaw) || typeof window === 'undefined') {
            return defaultPosition;
        }

        const maxX = Math.max(CHAT_PANEL_MARGIN, window.innerWidth - CHAT_PANEL_WIDTH - CHAT_PANEL_MARGIN);
        const minY = 60;
        const maxY = Math.max(minY, window.innerHeight - CHAT_PANEL_HEIGHT - CHAT_PANEL_MARGIN);
        return {
            x: Math.min(Math.max(xRaw, CHAT_PANEL_MARGIN), maxX),
            y: Math.min(Math.max(yRaw, minY), maxY)
        };
    }

    resolveInitialChatPosition = (position) => {
        if (position && Number.isFinite(parseFloat(position.x)) && Number.isFinite(parseFloat(position.y))) {
            return this.clampChatPosition(position);
        }
        return this.getDefaultChatPosition();
    }

    persistChatMemory = (override = {}) => {
        saveMapChatMemory({
            messages: (override.messages !== undefined ? override.messages : this.state.chatMessages),
            position: (override.position !== undefined ? override.position : this.state.chatPosition),
            collapsed: (override.collapsed !== undefined ? override.collapsed : this.state.chatCollapsed)
        });
    }

    handleWindowResize = () => {
        if (!this.state.chatEnabled) {
            return;
        }

        const nextPosition = this.clampChatPosition(this.state.chatPosition || this.getDefaultChatPosition());
        this.setState({ chatPosition: nextPosition });
    }

    createChatMessage = (role, content) => {
        return {
            id: Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8),
            role: role,
            content: (content || '').toString().trim(),
            created_at: Date.now()
        };
    }

    normalizeChatToken = (value) => {
        if (value === null || value === undefined) {
            return '';
        }
        return value.toString().trim().toLowerCase();
    }

    normalizeTitleToken = (value) => {
        const raw = this.normalizeChatToken(value);
        if (!raw) {
            return '';
        }

        return raw
            .replace(/[^a-z0-9\s]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    getEmptyGeoJSON = () => {
        return { type: 'FeatureCollection', features: [] };
    }

    toChatApiMessages = (messages) => {
        if (!Array.isArray(messages)) {
            return [];
        }

        return messages
            .filter((entry) => (
                entry &&
                (entry.role === 'user' || entry.role === 'assistant') &&
                typeof entry.content === 'string' &&
                entry.content.trim().length > 0
            ))
            .slice(-12)
            .map((entry) => ({
                role: entry.role,
                content: entry.content
            }));
    }

    buildMapChatContext = () => {
        const businessesInArea = (Array.isArray(this.chatBusinessesFromGeoCall) ? this.chatBusinessesFromGeoCall : []);
        const visibleBusinesses = (this.dataPoints && Array.isArray(this.dataPoints.businesses) ? this.dataPoints.businesses : []);
        const spots = (this.dataPoints && Array.isArray(this.dataPoints.directory) ? this.dataPoints.directory : []);
        const usersCount = (this.dataPoints && Array.isArray(this.dataPoints.users) ? this.dataPoints.users.length : 0);
        const centerLat = (this.coordinates ? truncate(this.coordinates.latitude, 4) : '');
        const centerLng = (this.coordinates ? truncate(this.coordinates.longitude, 4) : '');
        const radiusKm = (Number.isFinite(this.searchRadiusMeters) ? (this.searchRadiusMeters / 1000).toFixed(1) : '0');

        const businessesPayload = businessesInArea
            .map((entry, idx) => {
                const title = ((entry && (entry.title || entry.name || entry.event_name || entry.place || entry.companyname)) || 'Untitled').toString();
                const category = ((entry && (entry.type || entry.category || entry.icon)) || '').toString();
                const startsAt = ((entry && (entry.date_start || entry.start_date || entry.start)) || '').toString();
                const city = ((entry && (entry.city || (entry.business && entry.business.city))) || '').toString();
                const where = ((entry && (entry.address || (entry.business && entry.business.address))) || '').toString();
                return (
                    (idx + 1) + '. ' + title +
                    (category ? (' | type: ' + category) : '') +
                    (city ? (' | city: ' + city) : '') +
                    (where ? (' | address: ' + where) : '') +
                    (startsAt ? (' | starts: ' + startsAt) : '')
                );
            })
            .join('\n');

        const spotsPreview = spots
            .slice(0, 8)
            .map((entry, idx) => (idx + 1) + '. ' + ((entry && (entry.title || entry.name || entry.place || entry.business_name)) || 'Untitled spot'))
            .join('\n');

        return [
            'Center: ' + centerLat + ', ' + centerLng,
            'Search radius: ' + radiusKm + ' km',
            'Visible users: ' + usersCount,
            'Visible events on map (after UI filters): ' + visibleBusinesses.length,
            'Businesses from geolocation API response (full area): ' + businessesInArea.length,
            (businessesPayload ? ('All businesses from geolocation response:\n' + businessesPayload) : 'All businesses from geolocation response: none'),
            'Visible spots: ' + spots.length,
            (spotsPreview ? ('Spot names:\n' + spotsPreview) : 'Spot names: none')
        ].join('\n');
    }

    toChatEventKeyToken = (value) => {
        return this.normalizeChatToken(value);
    }

    getEventIdentityKeys = (entry) => {
        if (!entry || typeof entry !== 'object') {
            return [];
        }

        const idEvent = this.toChatEventKeyToken(
            entry.id_event ||
            entry.idEvent ||
            entry.event_id ||
            entry.id ||
            entry.identity
        );
        const idBusiness = this.toChatEventKeyToken(
            entry.id_business ||
            (entry.business && entry.business.id_business)
        );

        const keys = [];
        if (idEvent) {
            keys.push(idEvent);
            if (idBusiness) {
                keys.push(idEvent + '::' + idBusiness);
            }
        }
        if (idBusiness) {
            keys.push('business::' + idBusiness);
        }

        return Array.from(new Set(keys));
    }

    getEventTitleTokens = (entry) => {
        if (!entry || typeof entry !== 'object') {
            return [];
        }

        const title = (
            entry.title ||
            entry.name ||
            entry.event_name ||
            entry.place ||
            (entry.business && entry.business.companyname) ||
            ''
        );
        const token = this.normalizeTitleToken(title);
        return (token ? [token] : []);
    }

    buildTitleHintsFromReply = (replyText) => {
        const normalizedReply = this.normalizeTitleToken(replyText);
        if (!normalizedReply || normalizedReply.length < 4) {
            return [];
        }

        const titleHints = new Set();
        const businesses = (Array.isArray(this.chatBusinessesFromGeoCall) ? this.chatBusinessesFromGeoCall : []);
        businesses.forEach((entry) => {
            this.getEventTitleTokens(entry).forEach((token) => {
                if (token.length >= 4 && normalizedReply.includes(token)) {
                    titleHints.add(token);
                }
            });
        });
        return Array.from(titleHints);
    }

    getRecommendedMatchesFromResponse = (responsePayload) => {
        const keys = new Set();
        const titleHints = new Set();
        const recommendedEventIds = (responsePayload && Array.isArray(responsePayload.recommendedEventIds)
            ? responsePayload.recommendedEventIds
            : []
        );
        const eventsRaw = (responsePayload && Array.isArray(responsePayload.eventsRaw)
            ? responsePayload.eventsRaw
            : []
        );

        recommendedEventIds.forEach((value) => {
            if (typeof value === 'string' || typeof value === 'number') {
                const raw = value.toString();
                raw
                    .split(/[\n,;]+/g)
                    .map((part) => this.toChatEventKeyToken(part))
                    .filter((token) => token.length > 0)
                    .forEach((token) => keys.add(token));
            } else if (value && typeof value === 'object') {
                this.getEventIdentityKeys(value).forEach((token) => keys.add(token));
                this.getEventTitleTokens(value).forEach((token) => titleHints.add(token));
            }
        });

        eventsRaw.forEach((event) => {
            this.getEventIdentityKeys(event).forEach((token) => keys.add(token));
            this.getEventTitleTokens(event).forEach((token) => titleHints.add(token));
        });

        if (titleHints.size === 0) {
            this.buildTitleHintsFromReply(responsePayload && responsePayload.replyText).forEach((token) => titleHints.add(token));
        }

        return {
            keys: Array.from(keys),
            titleHints: Array.from(titleHints)
        };
    }

    buildChatSuggestionOverlay = (eventsRaw) => {
        if (!Array.isArray(eventsRaw) || eventsRaw.length === 0) {
            return this.getEmptyGeoJSON();
        }

        const features = [];
        const dedupe = new Set();
        eventsRaw.forEach((event) => {
            const coordinates = this.readItemCoordinates(event);
            if (!coordinates) {
                return;
            }

            const lng = parseFloat(coordinates.longitude);
            const lat = parseFloat(coordinates.latitude);
            if (!Number.isFinite(lng) || !Number.isFinite(lat)) {
                return;
            }

            const key = lng.toFixed(6) + ':' + lat.toFixed(6);
            if (dedupe.has(key)) {
                return;
            }
            dedupe.add(key);

            const title = (
                event.title ||
                event.name ||
                event.event_name ||
                event.place ||
                ''
            ).toString();
            features.push({
                type: 'Feature',
                properties: {
                    title: title,
                    chat_suggestion: true
                },
                geometry: {
                    type: 'Point',
                    coordinates: [lng, lat]
                }
            });
        });

        return {
            type: 'FeatureCollection',
            features: features
        };
    }

    applyChatHighlightsToMapState = () => {
        if (!this.dataPoints) {
            return;
        }

        const businessesForMap = this.decorateBusinessesForMap(this.dataPoints.businesses);
        const dataBusinesses = jsonToGeoJSONBusiness(businessesForMap);
        this.setState({
            dataBusinesses: dataBusinesses,
            dataChatSuggestions: (this.chatSuggestionOverlay || this.getEmptyGeoJSON())
        });
    }

    clearChatHighlights = (withMapUpdate = true) => {
        this.chatSuggestionOverlay = this.getEmptyGeoJSON();
        this.setState({
            chatRecommendedEventKeys: [],
            chatRecommendedTitleHints: [],
            dataChatSuggestions: this.chatSuggestionOverlay
        }, () => {
            if (withMapUpdate) {
                this.applyChatHighlightsToMapState();
            }
        });
    }

    handleClearChatHighlights = () => {
        this.clearChatHighlights(true);
    }

    getBusinessDisplayTitle = (entry) => {
        if (!entry || typeof entry !== 'object') {
            return 'Suggested event';
        }
        return (
            entry.title ||
            entry.name ||
            entry.event_name ||
            entry.place ||
            (entry.business && entry.business.companyname) ||
            'Suggested event'
        ).toString();
    }

    getBusinessDisplaySubtitle = (entry) => {
        if (!entry || typeof entry !== 'object') {
            return '';
        }
        const city = (
            entry.city ||
            (entry.business && entry.business.city) ||
            ''
        ).toString();
        const date = (
            entry.date_start ||
            entry.start_date ||
            entry.start ||
            entry.date ||
            ''
        ).toString();

        if (city && date) {
            return city + ' • ' + date;
        }
        return (city || date || '');
    }

    buildChatSuggestedEvents = (recommendations, responsePayload) => {
        const suggested = [];
        const dedupe = new Set();
        const businesses = (this.dataPoints && Array.isArray(this.dataPoints.businesses) ? this.dataPoints.businesses : []);
        const eventsRaw = (responsePayload && Array.isArray(responsePayload.eventsRaw) ? responsePayload.eventsRaw : []);
        const recommendedKeys = (recommendations && Array.isArray(recommendations.keys) ? recommendations.keys : []);
        const recommendedTitleHints = (recommendations && Array.isArray(recommendations.titleHints) ? recommendations.titleHints : []);

        businesses.forEach((entry) => {
            if (!this.doesBusinessMatchRecommendations(entry, recommendedKeys, recommendedTitleHints)) {
                return;
            }
            const coordinates = this.readItemCoordinates(entry);
            if (!coordinates) {
                return;
            }
            const idBase = (this.getEventIdentityKeys(entry)[0] || this.getBusinessDisplayTitle(entry));
            const id = 'loaded:' + idBase + ':' + coordinates.latitude + ':' + coordinates.longitude;
            if (dedupe.has(id)) {
                return;
            }
            dedupe.add(id);
            suggested.push({
                id: id,
                title: this.getBusinessDisplayTitle(entry),
                subtitle: this.getBusinessDisplaySubtitle(entry),
                coordinates: coordinates,
                popupData: this.toPopupDataForSuggestion(entry, coordinates)
            });
        });

        eventsRaw.forEach((entry) => {
            const coordinates = this.readItemCoordinates(entry);
            if (!coordinates) {
                return;
            }
            const title = this.getBusinessDisplayTitle(entry);
            const idBase = (this.getEventIdentityKeys(entry)[0] || title);
            const id = 'raw:' + idBase + ':' + coordinates.latitude + ':' + coordinates.longitude;
            if (dedupe.has(id)) {
                return;
            }
            dedupe.add(id);
            suggested.push({
                id: id,
                title: title,
                subtitle: this.getBusinessDisplaySubtitle(entry),
                coordinates: coordinates,
                popupData: this.toPopupDataForSuggestion(entry, coordinates)
            });
        });

        return suggested.slice(0, 8);
    }

    toPopupDataForSuggestion = (entry, coordinates) => {
        if (!entry || typeof entry !== 'object' || !coordinates) {
            return null;
        }

        const popupData = { ...entry };
        let position = popupData.position;
        if (typeof position === 'string') {
            try {
                position = JSON.parse(position);
            } catch (error) {
                position = null;
            }
        }

        if (Array.isArray(position) && Array.isArray(position[0])) {
            popupData.position = position;
        } else if (Array.isArray(position) && position.length >= 2) {
            popupData.position = [position];
        } else {
            popupData.position = [[coordinates.longitude, coordinates.latitude]];
        }

        if (typeof popupData.images === 'string') {
            try {
                popupData.images = JSON.parse(popupData.images);
            } catch (error) {
                popupData.images = [];
            }
        }

        if (typeof popupData.promotion === 'string') {
            try {
                popupData.promotion = JSON.parse(popupData.promotion);
            } catch (error) {
                popupData.promotion = [];
            }
        }

        if (typeof popupData.business === 'string') {
            try {
                popupData.business = JSON.parse(popupData.business);
            } catch (error) {
                popupData.business = {};
            }
        }

        return popupData;
    }

    handleChatSuggestedEventSelect = (id) => {
        const suggestions = (Array.isArray(this.state.chatSuggestedEvents) ? this.state.chatSuggestedEvents : []);
        const selected = suggestions.find((entry) => entry && entry.id === id);
        if (!selected || !selected.coordinates) {
            return;
        }

        const target = {
            latitude: parseFloat(selected.coordinates.latitude),
            longitude: parseFloat(selected.coordinates.longitude)
        };
        if (!Number.isFinite(target.latitude) || !Number.isFinite(target.longitude)) {
            return;
        }

        this.coordinates = target;
        this.setState({
            latitude: target.latitude,
            longitude: target.longitude,
            bPopUp: (selected.popupData ? true : this.state.bPopUp),
            popUpData: (selected.popupData ? selected.popupData : this.state.popUpData)
        });
    }

    doesBusinessMatchRecommendations = (business, recommendedKeys, recommendedTitleHints) => {
        if (recommendedKeys.length === 0 && recommendedTitleHints.length === 0) {
            return false;
        }

        const businessKeys = this.getEventIdentityKeys(business);
        const businessTitleTokens = this.getEventTitleTokens(business);

        if (businessKeys.length > 0 && recommendedKeys.length > 0) {
            const recommendedLookup = new Set(recommendedKeys.map((entry) => this.toChatEventKeyToken(entry)));
            if (businessKeys.some((token) => recommendedLookup.has(token))) {
                return true;
            }
        }

        if (businessTitleTokens.length > 0 && recommendedTitleHints.length > 0) {
            const titleLookup = new Set(recommendedTitleHints.map((entry) => this.normalizeTitleToken(entry)));
            if (businessTitleTokens.some((token) => titleLookup.has(token))) {
                return true;
            }
        }

        return false;
    }

    isRecommendedBusiness = (business) => {
        const recommendedKeys = (Array.isArray(this.state.chatRecommendedEventKeys)
            ? this.state.chatRecommendedEventKeys
            : []
        );
        const recommendedTitleHints = (Array.isArray(this.state.chatRecommendedTitleHints)
            ? this.state.chatRecommendedTitleHints
            : []
        );
        return this.doesBusinessMatchRecommendations(business, recommendedKeys, recommendedTitleHints);
    }

    decorateBusinessesForMap = (businesses) => {
        if (!Array.isArray(businesses) || businesses.length === 0) {
            return [];
        }

        return businesses.map((entry) => ({
            ...entry,
            chat_recommended: this.isRecommendedBusiness(entry)
        }));
    }

    toBackendTimeWindow = () => {
        if (!Array.isArray(this.range) || this.range.length < 2) {
            return null;
        }

        return {
            start: this.range[0],
            end: this.range[1]
        };
    }

    sendChatWithMode = async (text, pendingMessages) => {
        const isBackendMode = this.state.chatMode === 'backend';
        if (isBackendMode) {
            try {
                const backendResponse = await sendMapChatMessageViaBackend({
                    query: text,
                    conversation: this.toChatApiMessages(pendingMessages),
                    userLocation: this.coordinates,
                    radiusMeters: this.searchRadiusMeters,
                    zoom: this.zoom,
                    timeWindow: this.toBackendTimeWindow(),
                    targetAreaText: '',
                    limit: 8,
                    loadedBusinesses: this.chatBusinessesFromGeoCall
                });
                return backendResponse;
            } catch (backendError) {
                if (!mapChatFallbackToFrontend) {
                    throw backendError;
                }

                const fallbackText = await sendMapChatMessage({
                    messages: this.toChatApiMessages(pendingMessages),
                    contextSummary: this.buildMapChatContext()
                });
                return {
                    replyText: fallbackText,
                    recommendedEventIds: [],
                    eventsRaw: [],
                    meta: {
                        mode: 'frontend_fallback',
                        backend_error: (backendError && backendError.message ? backendError.message : 'backend_failed')
                    }
                };
            }
        }

        const assistantText = await sendMapChatMessage({
            messages: this.toChatApiMessages(pendingMessages),
            contextSummary: this.buildMapChatContext()
        });
        return {
            replyText: assistantText,
            recommendedEventIds: [],
            eventsRaw: [],
            meta: { mode: 'frontend' }
        };
    }

    handleChatSend = async (text) => {
        const value = (text || '').toString().trim();
        if (!value || this.state.chatLoading) {
            return;
        }

        const userMessage = this.createChatMessage('user', value);
        const pendingMessages = [...this.state.chatMessages, userMessage];

        this.setState({
            chatMessages: pendingMessages,
            chatLoading: true,
            chatError: ''
        });
        this.persistChatMemory({ messages: pendingMessages });

        try {
            const responsePayload = await this.sendChatWithMode(value, pendingMessages);
            const assistantMessage = this.createChatMessage('assistant', responsePayload.replyText);
            const finalMessages = [...pendingMessages, assistantMessage];
            const recommendations = this.getRecommendedMatchesFromResponse(responsePayload);
            const suggestedEvents = this.buildChatSuggestedEvents(recommendations, responsePayload);
            this.chatSuggestionOverlay = this.buildChatSuggestionOverlay(responsePayload.eventsRaw);
            this.setState({
                chatMessages: finalMessages,
                chatLoading: false,
                chatError: '',
                chatRecommendedEventKeys: recommendations.keys,
                chatRecommendedTitleHints: recommendations.titleHints,
                chatSuggestedEvents: suggestedEvents,
                dataChatSuggestions: this.chatSuggestionOverlay,
                chatBackendMeta: (responsePayload.meta || null)
            }, () => {
                this.applyChatHighlightsToMapState();
            });
            this.persistChatMemory({ messages: finalMessages });
        } catch (error) {
            const fallbackMessage = this.createChatMessage(
                'assistant',
                'I could not connect to the assistant right now. Please try again.'
            );
            const finalMessages = [...pendingMessages, fallbackMessage];
            this.chatSuggestionOverlay = this.getEmptyGeoJSON();
            this.setState({
                chatMessages: finalMessages,
                chatLoading: false,
                chatError: (error && error.message ? error.message : 'Chat request failed.'),
                chatRecommendedEventKeys: [],
                chatRecommendedTitleHints: [],
                chatSuggestedEvents: [],
                dataChatSuggestions: this.getEmptyGeoJSON()
            });
            this.applyChatHighlightsToMapState();
            this.persistChatMemory({ messages: finalMessages });
        }
    }

    handleClearChat = () => {
        this.chatSuggestionOverlay = this.getEmptyGeoJSON();
        this.setState({
            chatMessages: [],
            chatLoading: false,
            chatError: '',
            chatRecommendedEventKeys: [],
            chatRecommendedTitleHints: [],
            chatSuggestedEvents: [],
            dataChatSuggestions: this.chatSuggestionOverlay,
            chatBackendMeta: null
        }, () => {
            this.applyChatHighlightsToMapState();
        });
        this.persistChatMemory({ messages: [] });
    }

    handleChatPositionChange = (position, persist = false) => {
        const nextPosition = this.clampChatPosition(position);
        this.setState({ chatPosition: nextPosition });
        if (persist) {
            this.persistChatMemory({ position: nextPosition });
        }
    }

    handleChatCollapsedChange = (collapsed) => {
        const nextCollapsed = !!collapsed;
        this.setState({ chatCollapsed: nextCollapsed });
        this.persistChatMemory({ collapsed: nextCollapsed });
    }

    handleChatVisibilityToggle = () => {
        this.setState((prevState) => ({
            chatVisible: !prevState.chatVisible,
            chatCollapsed: (!prevState.chatVisible ? false : prevState.chatCollapsed)
        }));
    }

    handleHideChat = () => {
        this.setState({ chatVisible: false });
    }

    getSearchCircleRadiusMeters = (coordinates, zoom) => {
        if (!coordinates || typeof window === 'undefined') {
            return 0;
        }

        const latitude = parseFloat(coordinates.latitude);
        const zoomLevel = parseFloat(zoom || 16);
        if (!Number.isFinite(latitude) || !Number.isFinite(zoomLevel)) {
            return 0;
        }

        const diameterPx = Math.min(window.innerWidth, window.innerHeight) * 0.75;
        const radiusPx = diameterPx / 2;
        const metersPerPixel = 156543.03392 * Math.cos(latitude * Math.PI / 180) / Math.pow(2, zoomLevel);
        return Math.max(0, radiusPx * metersPerPixel);
    }

    normalizePairToCoordinates = (pair, referenceCoordinates) => {
        if (!Array.isArray(pair) || pair.length < 2) {
            return null;
        }

        const first = parseFloat(pair[0]);
        const second = parseFloat(pair[1]);

        const candidateA = { latitude: first, longitude: second };
        const candidateB = { latitude: second, longitude: first };

        const isValidCandidate = (candidate) => (
            Number.isFinite(candidate.latitude) &&
            Number.isFinite(candidate.longitude) &&
            Math.abs(candidate.latitude) <= 90 &&
            Math.abs(candidate.longitude) <= 180
        );

        const validA = isValidCandidate(candidateA);
        const validB = isValidCandidate(candidateB);

        if (!validA && !validB) {
            return null;
        }

        if (validA && !validB) {
            return candidateA;
        }

        if (!validA && validB) {
            return candidateB;
        }

        if (!referenceCoordinates) {
            return candidateA;
        }

        const distanceA = calculateDistance(referenceCoordinates, candidateA);
        const distanceB = calculateDistance(referenceCoordinates, candidateB);
        return distanceA <= distanceB ? candidateA : candidateB;
    }

    readItemCoordinates = (item) => {
        if (!item || typeof item !== 'object') {
            return null;
        }

        let rawPosition = item.position || item.coordinates || null;
        if (typeof rawPosition === 'string') {
            try {
                rawPosition = JSON.parse(rawPosition);
            } catch (error) {
                rawPosition = null;
            }
        }

        if (Array.isArray(rawPosition) && Array.isArray(rawPosition[0])) {
            rawPosition = rawPosition[0];
        }

        return this.normalizePairToCoordinates(rawPosition, this.coordinates);
    }

    isWithinSearchCircle = (item, radiusMeters) => {
        if (!Number.isFinite(radiusMeters) || radiusMeters <= 0 || !this.coordinates) {
            return true;
        }

        const itemCoordinates = this.readItemCoordinates(item);
        if (!itemCoordinates) {
            return true;
        }

        const distance = calculateDistance(this.coordinates, itemCoordinates);
        return distance <= radiusMeters;
    }

    applySearchCircleFilter = (items, radiusMeters) => {
        if (!Array.isArray(items)) {
            return items;
        }

        return items.filter((item) => this.isWithinSearchCircle(item, radiusMeters));
    }
    
    // ##################################  GET FILTERS  ####################################
    // ##################################  GET FILTERS  ####################################
    getFilters = filters => {
        this.filters = filters;
        this.filterResults();
    }

    // ##################################  GET GEOLOCATION OF PLACE  ####################################
    // ##################################  RETURNS LIST OF MATCHING PLACES  ####################################
    getPlace = async (data) => {

        if(data.length > 3){
            this.suggestions = await geoCodeAddress(data, this.coordinates);
            // console.log('- getplace : ', this.suggestions, ' => ', data, ' => ', this.coordinates);
        } else{ this.suggestions=[]; }
        
        this.preRender();
    }

    // ################################## PRERENDER  ####################################
    // ################################## PRERENDER  ####################################
    preRender = () => {

        try{

            const data2 = jsonToGeoJSON(this.filteredDataPoints);

            let businessesForMap = this.decorateBusinessesForMap(this.dataPoints.businesses);
            let directoryForMap = (this.dataPoints.directory ? this.dataPoints.directory : []);

            if (this.activeCategories.size > 0) {
                businessesForMap = businessesForMap.filter(entry => {
                    const cat = getSpotCategory(entry, 'business');
                    return cat && this.activeCategories.has(cat.key);
                });
                directoryForMap = directoryForMap.filter(entry => {
                    const cat = getSpotCategory(entry, 'directory');
                    return cat && this.activeCategories.has(cat.key);
                });
            }

            const data3 = jsonToGeoJSONBusiness(businessesForMap);
            const data4 = jsonToGeoJSONDirectory(directoryForMap);
            let emptyResults = (Array.isArray(this.dataPoints.businesses) ? this.dataPoints.businesses.length === 0 : true);
            const data5 = (this.chatSuggestionOverlay || this.getEmptyGeoJSON());

            const data = { dataPoints: data2, dataBusinesses: data3, dataDirectory: data4, dataChatSuggestions: data5, latitude: this.coordinates['latitude'], longitude: this.coordinates['longitude'], loading: true, searchRadiusMeters: this.searchRadiusMeters };
            this.setState(data, function(){            
                setTimeout(() => {
                    this.setState({loading: false, refresh: true, emptyResults: emptyResults });
                }, 1000);
            });
        }
        catch(e){
            console.log('error: ', e);
            this.setState({loading: false, refresh: true });
        }
    }
    
    // ##################################  RENDER  ####################################
    // ##################################  RENDER  ####################################
    render(){
        if(this.state.longitude){
            const isDarkTheme = this.state.theme === 'dark';
            const isRefreshBusy = this.state.isRefreshing || this.state.loading;
            const refreshLabel = (isRefreshBusy ? 'Searching events...' : 'Search for events in the circle area');
            const refreshButtonStyle = {
                padding: '11px 22px',
                minWidth: '300px',
                marginLeft: '10px',
                fontSize: '15px',
                fontWeight: 700,
                color: '#ffffff',
                background: (isRefreshBusy ? (isDarkTheme ? '#6f3a45' : '#ba6370') : 'linear-gradient(135deg, #ad182f 0%, #c7354b 100%)'),
                border: (isDarkTheme ? '1px solid rgba(255, 255, 255, 0.16)' : '1px solid rgba(127, 16, 34, 0.35)'),
                borderRadius: '999px',
                cursor: (isRefreshBusy ? 'default' : 'pointer'),
                outline: 'none',
                boxShadow: (isDarkTheme ? '0 10px 22px rgba(0, 0, 0, 0.44)' : '0 10px 22px rgba(66, 12, 22, 0.28)'),
                transition: 'transform 0.15s ease, box-shadow 0.2s ease, background 0.2s ease'
            };
            const refreshButtonMobileStyle = {
                ...refreshButtonStyle,
                minWidth: 'unset',
                width: '74vw',
                maxWidth: '300px',
                padding: '10px 16px',
                fontSize: '14px'
            };
            // console.log("===> ", this.state.bComplete, ' === ', this.state.infoModal);
            return ( 
                <div className={"BRL Wide100 "}>
                    {/*################################ MODAL POPUP ################################*/}
                    {/*################################ MODAL POPUP ################################*/}
                    {/* <InfoModal type={'geolocation'} show={(this.state.bComplete === false && this.state.infoModal === null ? true:false)} onClose={() => {this.setState({infoModal: false})}} /> */}
                    {this.state.popUpData && <InfoModal type={'popUp'} data={this.state.popUpData} show={this.state.bPopUp} onClose={() => {this.setState({bPopUp: false})}} />}

                    {this.bdebug ===  true && <div className={"Fixed Top0px Right50px z2000 FS36 BCBlack FCWhite FuturaL"}>                            
                        {this.state.debugUserCoordinates} 
                    </div>}

                    <button
                        type="button"
                        className="geo-theme-toggle"
                        onClick={this.handleThemeToggle}
                        aria-label={isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'}
                        title={isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'}
                    >
                        <FontAwesomeIcon icon={(isDarkTheme ? "sun" : "moon")} />
                    </button>

                    {/*################################ DESKTOP ################################*/}
                    {/*################################ DESKTOP ################################*/}
                    <div className={"DesktopMenu Absolute Top0px Left0px col-lg-11 col-md-11 col-sm-11 HPadding0px VPadding10px z1001"}>
                        <div className={"DesktopMenu BRL col-lg-4 col-md-4 col-sm-12 VPadding10px MaxWide350px z1001"}>
                            <div className="BRL col-lg-12 col-md-12 col-sm-12 BottomMargin5px z2000 HPadding0 ">
                                <SearchBox title={true} icon="map" settings={this.props.settings.logo} 
                                iconLib="font-awesome" placeholder="search a place" loading={this.state.loading} 
                                onChange={(e) => this.getPlace(e)} 
                                onSubmit={(e) => {this.isChanged(e, this.zoom, 'search')}} 
                                onRefresh={() => {this.getResults()}}  
                                boxStyle={'Wide100'} 
                                suggestions={this.suggestions}/></div>
                            {/* {showGeoFilterUi && <div className="BRL col-lg-12 col-md-12 col-sm-12 z1000 HPadding0 "><FilterMenu2 data={this.filters} open={false} onFilter={e => this.getFilters(e)} /></div>} */}
                        </div>

                        <div className={"DesktopMenu Flex FlexRow JustifyCenter AlignCenter BRL col-lg-8 col-md-8 col-sm-12 z3000 geo-desktop-slider-col"}>
                            <RangeSlider onSlider={(e) => {this.getRange(e)}} />
                        </div>
                    </div>

                    {/*################################ MOBILE ################################*/}
                    {/*################################ MOBILE ################################*/}
                    {showGeoFilterUi && this.state.modal && <ModalFilter show={this.state.modal} data={this.filters} onClose={()=>{this.setState({modal: false});}} onFilter={e => this.getFilters(e)} /> }                   
                    <div className={"MobileMenu Absolute Top15px Left0px col-11 p-3 z2000 geo-mobile-slider-wrap"}>
                        <RangeSlider onSlider={(e) => {this.getRange(e)}} />
                    </div>

                    <div className={"MobileMenu Fixed Bottom0px Left0px MarginAuto col-lg-12 col-md-12 col-sm-12 TopMargin0px Padding0 z2000"} style={{zIndex: 3900}}>                            
                        <SearchMenuBar settings={this.props.settings} boxStyle={'Wide100 '} loading={this.state.loading} 
                            icon="map" iconLib="font-awesome" placeholder="search a place" onChange={(e) => this.getPlace(e)}  
                            onSubmit={(e) => {this.isChanged(e, this.zoom, 'search')}} onRefresh={() => {this.getResults()}} onFilter={() =>{this.setState({modal: true})}}
                            showFilter={showGeoFilterUi}
                            suggestions={this.suggestions}/>
                    </div>

                    {this.state.showRefreshMapButton &&
                        <React.Fragment>
                            <div className="DesktopMenu" style={{ position: 'fixed', left: '50%', bottom: '28px', transform: 'translateX(-50%)', zIndex: 3250 }}>
                                <button
                                    className="btn"
                                    onClick={this.handleRefreshMap}
                                    disabled={isRefreshBusy}
                                    style={refreshButtonStyle} >
                                    {isRefreshBusy && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '8px' }}></span>}
                                    {refreshLabel}
                                </button>
                            </div>
                            <div className="MobileMenu" style={{ position: 'fixed', left: '50%', bottom: '58px', transform: 'translateX(-50%)', zIndex: 3250 }}>
                                <button
                                    className="btn"
                                    onClick={this.handleRefreshMap}
                                    disabled={isRefreshBusy}
                                    style={refreshButtonMobileStyle} >
                                    {isRefreshBusy && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '8px' }}></span>}
                                    {refreshLabel}
                                </button>
                            </div>
                        </React.Fragment>
                    }
                    
                    {/*################ MAPBOX ################*/}
                    {/*################ MAPBOX ################*/}
                    <div className="BRL Wide100 High100VH">
                        <MapBox
                            idUser={this.props.user.idUser}
                            settings={this.props.settings}
                            styleMap={this.styleMap}
                            data={this.state}
                            chatEnabled={this.state.chatEnabled}
                            chatVisible={this.state.chatVisible}
                            onToggleChat={this.handleChatVisibilityToggle}
                            availableCategories={this.availableCategories}
                            activeCategories={this.activeCategories}
                            onCategoryFilterChange={this.handleCategoryFilterChange}
                            onChangeCenter={async (e, zoom, type) => { await this.isChanged(e, zoom, type); }}
                            onPopUp={data =>{this.displayPopUp(data)}}
                            onDblClick={(map, event) =>{} }/>

                        {/*################   ADS    ################*/}
                        {/*################ EXOCLICK ################*/}                        
                        {/* <div className="DesktopMenuAds Bottom20px Padding5px z4000 Fixed Left0">
                            <ins className="eas6a97888e2 " data-zoneid="5640234"></ins> 
                        </div> 

                        <div className="MobileMenuAds Top80px Padding5px z4000 Fixed Left0" >
                            <ins className="eas6a97888e2 " data-zoneid="5640234"></ins> 
                        </div>  */}

                    </div> 

                    {this.state.chatEnabled && this.state.chatVisible && (
                        <MapChatbot
                            messages={this.state.chatMessages}
                            loading={this.state.chatLoading}
                            error={this.state.chatError}
                            position={this.state.chatPosition}
                            collapsed={this.state.chatCollapsed}
                            suggestions={this.state.chatSuggestedEvents}
                            onSend={this.handleChatSend}
                            onClear={this.handleClearChat}
                            onClearHighlights={this.handleClearChatHighlights}
                            onHide={this.handleHideChat}
                            onSelectSuggestion={this.handleChatSuggestedEventSelect}
                            onPositionChange={this.handleChatPositionChange}
                            onCollapsedChange={this.handleChatCollapsedChange}
                        />
                    )}

            </div>);
        } else { 
            // return null;
            return ( 
                <div className={ this.props.settings.structure.outlet.class} style={styleMapping(this.props.settings.structure.outlet)}>
                    <div className={"Flex FlexCol JustifyCenter AlignCenter High100VH"} style={{backgroundColor: "rgba(240,240,240,0.5)"}}>
                        <div className="Monoton" style={{fontSize:'3rem', color:"#ad182f"}}>STRANGERS</div>
                        <div className={""}><FontAwesomeIcon className={"FS10 Spin"} icon={"compass"} color="#ad182f" /></div>
                    </div>
                </div>);
        }
    }

    
    // ##################################  FILTERING RESUKTS  ####################################
    // ##################################  FILTERING RESUKTS  ####################################
    filterResults = () => {    
        const filters = this.filters; 
        this.filteredDataPoints = [];
        
            if(this.dataPoints){
                if(this.dataPoints.users){
                this.filteredDataPoints = this.dataPoints.users.filter(function(item) {
                    let bDisplay = true;
                    for (var key in filters) {
                        let filters2 = filters[key];
                        let bDisplayOR = '';
                        // console.log('FILTERED 1 => ', key, ' : ', filters2);
                        
                        for (var key2 in filters2) {
                            let filters3 = filters2[key2]['value'];
                            // console.log('FILTERED 3 => ', filters2);
                            // console.log('FILTERS 3 => ', filters3);
                            switch(key){
                                case 'age': 
                                const temp = filters3.split("-");
                                if (parseInt(item['age'],10) < parseInt(temp[0],10) || parseInt(item['age'],10) > parseInt(temp[1],10)){ 
                                    if(bDisplayOR !== true) {bDisplayOR = false;} 
                                } else {bDisplayOR = true;}
                                break;
                                default: 
                                    // console.log('FILTERED 4 => ', filters[key], ' !== "" ');
                                    if (filters3 !=='' && item[getEquivalent(key, equivalentFields, 1)] !== filters3){ 
                                            if(bDisplayOR !== true) {bDisplayOR = false;} 
                                    } else {bDisplayOR = true; }
                                    break;
                                }
                        }
                        if(bDisplayOR === false) {bDisplay = false;} 
                    }
                    return bDisplay;
                });
            }
        }
        // console.log('GEOLOCATION GETREUSLTS FILTERED 1 => ', this.filteredDataPoints);
        this.preRender();
    }


    // ##################################  DISPLAY POPUP  ####################################
    // ##################################  DISPLAY POPUP  ####################################
    displayPopUp = (dataPopUp) => { 
        const data = {
            bPopUp: true, 
            popUpData: dataPopUp, 
            latitude: dataPopUp['position'][0][0], 
            longitude: dataPopUp['position'][0][1]
        };
        // console.log('displayPopUp 2 => ', dataPopUp, ' => ', data);   
        this.setState(data);
    }
}     

const mapStateToProps = (state) => {

    const data = {
        darkMode: (state.profile ? state.profile.is_dark_mode : null),
        profile: state.profile,
        settings: state.settings,
        control: state.control,
        directory: state.directory,
        email: state.email,
    }
	return data;
}

export default connect(mapStateToProps, null)(GeoLocation);

